import template from './wc-location-type.jade';
import wcLocationType from '../../../enums/wc-location-type';

export default angular
    .module('cian.addForm.wcLocationType', [])
    .directive('cianAfAboutObjectWcLocationType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.wcLocationTypeOptions = wcLocationType;
        },
        controllerAs: 'wcLocationType',
        template,
    }))
    .name;
